import { SATISFACTION_QUESTIONS_SERVICE } from "@/services/satisfactionQuestions.service.js";

const state = {
    getSatisfactionQuestionsOutput: {}, 
    postSatisfactionQuestionOutput: false, 
    putSatisfactionQuestionOutput: false, 
    deleteSatisfactionQuestionByIdOutput: false, 
    getSatisfactionQuestionDetailsOutput: {}
};

const actions = {
    //Service to get satisfaction questions
    getSatisfactionQuestions({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getSatisfactionQuestionsRequest');

        SATISFACTION_QUESTIONS_SERVICE.getSatisfactionQuestions(queryParams)
            .then(
                output => {
                    commit('getSatisfactionQuestionsSuccess', output);
                },
                error => {
                    commit('getSatisfactionQuestionsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to create satisfaction question
    postSatisfactionQuestion({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postSatisfactionQuestionRequest');

        SATISFACTION_QUESTIONS_SERVICE.postSatisfactionQuestion(input)
            .then(
                output => {
                    commit('postSatisfactionQuestionSuccess', output);
                    dispatch('alert/success', 'Pergunta criada com sucesso!', { root: true });
                },
                error => {
                    commit('postSatisfactionQuestionFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update satisfaction question
    putSatisfactionQuestion({ dispatch, commit }, { id, input }) {
        dispatch('alert/clear', null, { root: true });
        commit('putSatisfactionQuestionRequest');

        SATISFACTION_QUESTIONS_SERVICE.putSatisfactionQuestion(id, input)
            .then(
                output => {
                    commit('putSatisfactionQuestionSuccess', output);
                    dispatch('alert/success', 'Pergunta atualizada com sucesso!', { root: true });
                },
                error => {
                    commit('putSatisfactionQuestionFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to remove satisfaction question
    deleteSatisfactionQuestionById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteSatisfactionQuestionByIdRequest');

        SATISFACTION_QUESTIONS_SERVICE.deleteSatisfactionQuestionById(id)
            .then(
                output => {
                    commit('deleteSatisfactionQuestionByIdSuccess', output);
                    dispatch('alert/success', 'Pergunta removida com sucesso!', { root: true });
                },
                error => {
                    commit('deleteSatisfactionQuestionByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get satisfaction question details
    getSatisfactionQuestionDetails({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getSatisfactionQuestionDetailsRequest');

        SATISFACTION_QUESTIONS_SERVICE.getSatisfactionQuestionDetails(id)
            .then(
                output => {
                    commit('getSatisfactionQuestionDetailsSuccess', output);
                },
                error => {
                    commit('getSatisfactionQuestionDetailsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getSatisfactionQuestions
    getSatisfactionQuestionsRequest(state) {
    },
    getSatisfactionQuestionsSuccess(state, output) {
        state.getSatisfactionQuestionsOutput = output;
    },
    getSatisfactionQuestionsFailure(state) {
        state.getSatisfactionQuestionsOutput = false;
    },

    //postSatisfactionQuestion
    postSatisfactionQuestionRequest(state) {
        state.postSatisfactionQuestionOutput = null;
    },
    postSatisfactionQuestionSuccess(state, output) {
        state.postSatisfactionQuestionOutput = true;
    },
    postSatisfactionQuestionFailure(state) {
        state.postSatisfactionQuestionOutput = false;
    },

    //putSatisfactionQuestion
    putSatisfactionQuestionRequest(state) {
        state.putSatisfactionQuestionOutput = null;
    },
    putSatisfactionQuestionSuccess(state, output) {
        state.putSatisfactionQuestionOutput = true;
    },
    putSatisfactionQuestionFailure(state) {
        state.putSatisfactionQuestionOutput = false;
    },

    //deleteSatisfactionQuestionById
    deleteSatisfactionQuestionByIdRequest(state) {
        state.deleteSatisfactionQuestionByIdOutput = null;
    },
    deleteSatisfactionQuestionByIdSuccess(state, output) {
        state.deleteSatisfactionQuestionByIdOutput = true;
    },
    deleteSatisfactionQuestionByIdFailure(state) {
        state.deleteSatisfactionQuestionByIdOutput = false;
    },

    //getSatisfactionQuestionDetails
    getSatisfactionQuestionDetailsRequest(state) {
    },
    getSatisfactionQuestionDetailsSuccess(state, output) {
        state.getSatisfactionQuestionDetailsOutput = output;
    },
    getSatisfactionQuestionDetailsFailure(state) {
        state.getSatisfactionQuestionDetailsOutput = false;
    },
};

export const satisfactionQuestions = {
    namespaced: true,
    state,
    actions,
    mutations
};

